'use client'
import type { ReactNode } from 'react'
import { createContext, useContext } from 'react'

type ToastFn = (message: string) => void

let toastContainer: HTMLDivElement | null = null
function ensureContainer() {
  if (toastContainer) return toastContainer
  toastContainer = document.createElement('div')
  toastContainer.style.cssText = 'pointer-events:none;position:fixed;bottom:24px;left:0;right:0;z-index:99999;display:flex;flex-direction:column;align-items:center;gap:6px'
  document.body.appendChild(toastContainer)
  return toastContainer
}

function showToast(message: string) {
  const container = ensureContainer()
  const el = document.createElement('div')
  el.setAttribute('role', 'status')
  el.style.cssText = 'border-radius:4px;border:1px solid #d3813c;background:#d3813c;padding:8px 14px;font-family:monospace;font-size:14px;color:#fff;box-shadow:0 2px 8px rgba(0,0,0,0.15);white-space:nowrap'
  el.textContent = message
  container.appendChild(el)
  setTimeout(() => el.remove(), 2600)
}

const ToastContext = createContext<ToastFn>(showToast)
export const useToast = () => useContext(ToastContext)

export function ToastProvider({ children }: { children: ReactNode }) {
  return <ToastContext.Provider value={showToast}>{children}</ToastContext.Provider>
}